<div id="about-modal-header" class="modal-header">
  <button type="button" class="btn-close" (click)="closeModal()"></button>
</div>

<div class="modal-body">
  <div id="about-modal-logo">
    <img src="assets/images/logo-big@2x.png" alt="App logo" />
    <span class="text-gray-500 fw-bold text-center" data-cy="app-version">{{ appInfo.project }}</span>
  </div>

  <!-- Client -->
  <div class="row top-buffer">
    <h5 class="col text-center">{{ 'CLIENT' | agrTranslate }}</h5>
  </div>
  <div id="client-version" class="row">
    <div class="col text-gray-600 text-end">{{ 'VERSION' | agrTranslate }}</div>
    <div class="col" data-cy="client-version">{{ appInfo.client.version }}</div>
  </div>
  @if (appInfo.client.buildInfo) {
  <div id="client-build" class="row">
    <div class="col text-gray-600 text-end">{{ 'ABOUT_BUILD' | agrTranslate }}</div>
    <div class="col">{{ appInfo.client.buildInfo }}</div>
  </div>
  } @if (appInfo.client.imageVersion) {
  <div id="client-image-version" class="row">
    <div class="col text-gray-600 text-end">{{ 'IMAGE_VERSION' | agrTranslate }}</div>
    <div class="col" data-cy="client-image-version">{{ appInfo.client.imageVersion }}</div>
  </div>
  }
  <div class="row">
    <div class="col text-gray-600 text-end">{{ 'TIMEZONE' | agrTranslate }}</div>
    <div class="col">{{ clientTimezone }}</div>
  </div>

  <!-- API -->
  <div class="row top-buffer">
    <h5 class="col text-center">API</h5>
  </div>
  <div id="api-version" class="row">
    <div class="col text-gray-600 text-end">{{ 'VERSION' | agrTranslate }}</div>
    <div class="col" data-cy="api-version">{{ appInfo.api.version }}</div>
  </div>
  @if (appInfo.api.buildSuffix !== '0') {
  <div id="api-build" class="row">
    <div class="col text-gray-600 text-end">{{ 'ABOUT_BUILD' | agrTranslate }}</div>
    <div class="col">{{ appInfo.api.buildSuffix }}</div>
  </div>
  } @if (appInfo.api.imageVersion) {
  <div id="api-image-verison" class="row">
    <div class="col text-gray-600 text-end">{{ 'IMAGE_VERSION' | agrTranslate }}</div>
    <div class="col" data-cy="api-image-version">{{ appInfo.api.imageVersion }}</div>
  </div>
  }
  <!-- Database -->
  <div id="database-info">
    <div class="row top-buffer">
      <h5 class="col text-center">{{ 'DATABASE' | agrTranslate }}</h5>
    </div>
    <div class="row">
      <div class="col text-gray-600 text-end">{{ 'VERSION' | agrTranslate }}</div>
      <div class="col" data-cy="database-version">{{ appInfo.database.version }}</div>
    </div>
    @if (appInfo.api.imageVersion) {
    <div class="row">
      <div class="col text-gray-600 text-end">{{ 'IMAGE_VERSION' | agrTranslate }}</div>
      <div class="col">{{ appInfo.database.imageVersion }}</div>
    </div>
    }
    <div class="row">
      <div class="col text-gray-600 text-end">{{ 'ABOUT_SOURCE' | agrTranslate }}</div>
      <div class="col">{{ appInfo.api.dataSource }}</div>
    </div>
    <div class="row">
      <div class="col text-gray-600 text-end">{{ 'TIMEZONE' | agrTranslate }}</div>
      <ng-template #databaseTimezonePopContent>
        {{ 'DATABASE_TIMEZONE_UNDEFINED_INFO' | agrTranslate }}
      </ng-template>
      <div class="col">
        {{ serverTimezone }}
        @if (serverTimezone === 'UTC±0') {
        <button type="button" id="database-timezone-info" class="btn btn-help" [ngbPopover]="databaseTimezonePopContent" popoverTitle="">
          <i class="fa fa-exclamation-circle"></i>
        </button>
        }
      </div>
    </div>
  </div>

  <!-- Browser -->
  <div class="row top-buffer">
    <h5 class="col text-center">{{ 'BROWSER' | agrTranslate }}</h5>
  </div>
  <div id="browser-info" class="row">
    <div class="col text-gray-600 text-end">{{ 'NAME' | agrTranslate }}</div>
    <div class="col" [class.text-danger]="notChrome" data-cy="browser-version">
      {{ browserName }} {{ browserVersion }}
      @if (notChrome) {
      <button type="button" id="not-chrome-info" class="btn btn-help" [ngbPopover]="notChromePopContent">
        <i class="fa fa-question-circle"></i>
      </button>
      }
      <ng-template #notChromePopContent>
        <div class="multiline-popover">
          <p>{{ 'PLEASE_USE_CHROME' | agrTranslate }}</p>
        </div>
      </ng-template>
    </div>
  </div>
  <div id="user-agent" class="row">
    <div class="col text-gray-600 text-end">{{ 'ABOUT_USER_AGENT' | agrTranslate }}</div>
    @if (showUserAgentString) {
    <div class="col small" data-cy="user-agent">{{ userAgent }}</div>
    } @if (!showUserAgentString) {
    <div class="col agr-link" (click)="showUserAgentString = true" data-cy="user-agent-show-more">{{ 'NAV_SHOW_MORE' | agrTranslate }}</div>
    }
  </div>

  <!-- Language / Locale / App Settings -->
  <div id="app-settings-info">
    <div class="row top-buffer">
      <h5 class="col text-center">{{ 'APP_SETTINGS' | agrTranslate }}</h5>
    </div>
    <div class="row">
      <div class="col text-gray-600 text-end">{{ 'LANGUAGE' | agrTranslate }}</div>
      <div class="col" data-cy="language">{{ language }}</div>
    </div>
    <div class="row">
      <div class="col text-gray-600 text-end">{{ 'LOCALE' | agrTranslate }}</div>
      <div class="col" data-cy="locale">
        <span ngbTooltip="{{ 'DATE_LOCALE' | agrTranslate }}, {{ 'NUMBER_LOCALE' | agrTranslate }}">
          {{ dateLocale }}, {{ numberLocale }}
        </span>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer"></div>
